<template>
  <div>
    <v-tooltip
      :disabled="$vuetify.breakpoint.xs"
      color="#DCD8F3"
      content-class="arrow-up"
      bottom
    >
      <template #activator="{ on: onTooltip }">
        <v-btn
          depressed
          light
          outlined
          color="white"
          :ripple="false"
          height="32px"
          min-width="32px"
          v-on="{ ...onTooltip }"
          class="theme-border-3 d-flex align-center pa-0 mx-1 justify-center"
          :class="$vuetify.breakpoint.xs ? 'white--text rounded' : 'bg-white'"
          @click="flag = true"
        >
          <v-icon
            size="20"
            class="ma-0 pa-0"
            :color="$vuetify.breakpoint.xs ? 'white' : '#757096'"
            >mdi-filter-outline</v-icon
          >
        </v-btn>
      </template>
      <span class="dark-purple-text font-weight-bold">Apply Filter</span>
    </v-tooltip>
    <v-dialog
      @click:outside="titleSearchCalendar = null"
      v-model="flag"
      width="800"
      scrollable
    >
      <v-card>
        <!-- Title bar -->
        <v-card-title
          class="py-3 px-4 text-truncate dialog-title-border dark-purple-text"
        >
          <div class="d-flex justify-center align-center" style="width: 90%">
            Advanced Filters
          </div>

          <v-spacer></v-spacer>
          <v-icon
            small
            color="#757096"
            @click="(flag = false), (titleSearchCalendar = null)"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="py-4 custom-dialog">
          <!-- TITLE SEARCH FOR XS-SCREENS -->
          <v-row v-if="$vuetify.breakpoint.xs">
            <v-col cols="12" class="dark-purple-text body-2 font-weight-bold">
              Search by Title
              <div class="search-border mt-2 rounded">
                <v-text-field
                  autocomplete="off"
                  prepend-inner-icon="mdi-magnify"
                  background-color="white"
                  placeholder="Search Title"
                  class="body-2"
                  color="#757096"
                  hide-details
                  solo
                  flat
                  dense
                  v-model="titleSearchCalendar"
                >
                </v-text-field>
              </div>
            </v-col>
          </v-row>
          <!-- FILTER BY TASK CATEGORY -->
          <v-row>
            <v-col
              md="6"
              v-if="
                getSelectedCompany.role == 'owner' ||
                getSelectedCompany.role == 'admin' ||
                getSelectedCompany.role == 'team-manager'
              "
              class="py-1"
            >
              <div class="my-2">
                <div
                  class="dark-purple-text font-weight-bold text-capitalize body-2"
                >
                  By Task Category
                </div>
                <div class="d-flex my-2">
                  <!-- Show all Tasks Filter -->
                  <div
                    class="pointer pr-2 py-2 caption d-flex anchor-hover pointer"
                    @click="changeShowAll('all')"
                  >
                    <v-icon
                      small
                      color="#1cc283"
                      class="mr-3"
                      v-text="
                        getCalendarShowAllTasks == 'all'
                          ? 'mdi-checkbox-marked-circle'
                          : 'mdi-checkbox-blank-circle-outline'
                      "
                    ></v-icon>
                    <span
                      :class="
                        getCalendarShowAllTasks == 'all'
                          ? 'success-text font-weight-bold'
                          : ''
                      "
                    >
                      All Tasks
                    </span>
                    <v-spacer></v-spacer>
                  </div>
                  <!-- Show only Me Tasks Filter -->
                  <div
                    class="pa-2 caption d-flex anchor-hover pointer"
                    @click="changeShowAll('me')"
                  >
                    <v-icon
                      small
                      color="#1cc283"
                      class="mr-3"
                      v-text="
                        getCalendarShowAllTasks == 'me'
                          ? 'mdi-checkbox-marked-circle'
                          : 'mdi-checkbox-blank-circle-outline'
                      "
                    ></v-icon>
                    <span
                      :class="
                        getCalendarShowAllTasks == 'me'
                          ? 'success-text font-weight-bold'
                          : ''
                      "
                    >
                      My Tasks</span
                    >
                    <v-spacer></v-spacer>
                  </div>
                  <!--Show Others Tasks Filter -->
                  <div
                    v-if="getSelectedCompany.role != 'employee'"
                    class="pa-2 caption d-flex anchor-hover pointer"
                    @click="changeShowAll('others')"
                  >
                    <v-icon
                      small
                      color="#1cc283"
                      class="mr-3"
                      v-text="
                        getCalendarShowAllTasks == 'others'
                          ? 'mdi-checkbox-marked-circle'
                          : 'mdi-checkbox-blank-circle-outline'
                      "
                    ></v-icon>
                    <span
                      :class="
                        getCalendarShowAllTasks == 'others'
                          ? 'success-text font-weight-bold'
                          : ''
                      "
                      >Others Tasks</span
                    >
                    <v-spacer></v-spacer>
                  </div>
                </div>
              </div>
            </v-col>
            <div
              v-if="
                !$vuetify.breakpoint.xs && getSelectedCompany.role != 'employee'
              "
              class="border-right my-5 ml-n2 mr-3"
            ></div>
            <!-- By due date/ created at -->
            <v-col>
              <p class="dark-purple-text font-weight-bold body-2 mb-3">
                By Time
              </p>
              <div class="d-flex caption">
                <v-chip
                  @click="changeTaskDueDateFilter(false)"
                  small
                  :class="
                    getCalendarTaskDueDateFilter == false
                      ? 'blue-chip-color'
                      : 'grey-chip-color '
                  "
                  class="grey-chip-color pointer"
                >
                  Created At
                </v-chip>

                <v-chip
                  @click="changeTaskDueDateFilter(true)"
                  small
                  :class="
                    getCalendarTaskDueDateFilter == true
                      ? 'blue-chip-color'
                      : 'grey-chip-color'
                  "
                  class="pointer ml-3"
                >
                  Due Date</v-chip
                >
              </div>
            </v-col>
          </v-row>
          <div class="border-bottom my-5"></div>

          <!-- FILTER BY TASK DESCRIPTION -->
          <v-row no-gutters>
            <v-col cols="12">
              <div
                class="font-weight-bold mt-3 dark-purple-text body-2 text-capitalize"
              >
                By task description
              </div>
            </v-col>
            <!-- Project -->
            <v-col cols="12" md="6">
              <div
                :class="
                  !$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm
                    ? 'mr-2 '
                    : ''
                "
              >
                <p class="dusty-purple-text mt-2 mb-0">Project</p>
                <div
                  id="calendar-project-dropdown"
                  class="theme-border d-flex align-center border-radius-2 px-2 py-2 pointer"
                  @click="projectSearch = null"
                >
                  <v-chip
                    v-if="getSearchedCalendarProject"
                    x-small
                    color="blue-chip-color"
                    >{{ getSearchedCalendarProject.name }}</v-chip
                  >
                  <v-spacer></v-spacer>
                  <v-icon small color="#2a206a">mdi-chevron-down</v-icon>
                </div>
              </div>
            </v-col>
            <!-- Assigned to -->
            <v-col
              v-if="
                getSelectedCompany.role == 'owner' ||
                getSelectedCompany.role == 'admin' ||
                getSelectedCompany.role == 'team-manager'
              "
              md="6"
              cols="12"
            >
              <div
                :class="
                  !$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm
                    ? 'ml-4'
                    : ''
                "
              >
                <p class="dusty-purple-text mt-2 mb-0">Assigned To</p>
                <div
                  id="calendar-assigned-to-dropdown"
                  class="theme-border d-flex align-center border-radius-2 px-2 py-2 pointer"
                  @click="
                    $store.dispatch('fetchTeamMembers');
                    searchMember = null;
                  "
                >
                  <v-chip
                    v-if="getSearchedCalendarAssignedTo"
                    class="pl-2 pr-3"
                    x-small
                    color="blue-chip-color"
                  >
                    <span class="d-inline-block text-truncate">
                      {{
                        getSearchedCalendarAssignedTo.name
                          ? getSearchedCalendarAssignedTo.name
                          : getSearchedCalendarAssignedTo.email
                      }}
                    </span>
                  </v-chip>
                  <v-spacer></v-spacer>
                  <v-icon small color="#2a206a">mdi-chevron-down</v-icon>
                </div>
              </div>
            </v-col>
            <!-- Assigned By -->
            <v-col
              md="6"
              cols="12"
              v-if="
                (getSelectedCompany.role == 'owner' &&
                  getCalendarShowAllTasks != 'me') ||
                (getSelectedCompany.role == 'admin' &&
                  getCalendarShowAllTasks != 'me') ||
                (getSelectedCompany.role == 'team-manager' &&
                  getCalendarShowAllTasks != 'me') ||
                getSelectedCompany.role == 'employee'
              "
            >
              <p class="dusty-purple-text mt-2 mb-0">Assigned By</p>
              <!-- Assigned By Dropdown -->
              <v-menu
                :close-on-content-click="false"
                offset-y
                content-class="white"
                v-model="assignedByDropdown"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div
                    id="calendar-assigned-by-dropdown"
                    :class="
                      !$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm
                        ? 'mr-2 '
                        : ''
                    "
                    v-bind="attrs"
                    v-on="on"
                    @click="searchMember = null"
                    class="theme-border d-flex align-center border-radius-2 px-2 py-2 pointer"
                  >
                    <v-chip
                      v-if="getSearchedCalendarAssignedBy"
                      class="pl-2 pr-3"
                      x-small
                      color="blue-chip-color"
                    >
                      <span class="d-inline-block text-truncate">
                        {{
                          getSearchedCalendarAssignedBy.name
                            ? getSearchedCalendarAssignedBy.name
                            : getSearchedCalendarAssignedBy.email
                        }}
                      </span>
                    </v-chip>
                    <v-spacer></v-spacer>
                    <v-icon small color="#2a206a">mdi-chevron-down</v-icon>
                  </div>
                </template>
                <div :class="isMac ? 'edited_scrollbar' : ''">
                  <!-- search field -->
                  <div class="search-border rounded ma-2">
                    <v-text-field
                      autocomplete="off"
                      prepend-inner-icon="mdi-magnify"
                      background-color="white"
                      placeholder="Search..."
                      class="body-2"
                      color="#757096"
                      hide-details
                      solo
                      dense
                      flat
                      v-model="searchMember"
                    />
                  </div>
                  <v-list max-height="130" class="overflow-scroll" scrollable>
                    <div
                      v-if="!searchMember"
                      class="d-flex list-item-min-height caption listing-hover pointer"
                      @click="
                        $store.commit('setCalendarTaskFilter', {
                          assigned_by: null,
                          page: 1,
                        });
                        fetchCall();
                      "
                      :class="
                        !getSearchedCalendarAssignedBy ? 'bg-selected' : ''
                      "
                    >
                      <profileImage
                        v-show="':username'"
                        inline
                        username="All"
                        :size="23"
                        :userProfile="true"
                        :circular="true"
                        class="ml-3 text-light"
                      >
                      </profileImage>
                      <v-list-item-content
                        @click="assignedByDropdown = false"
                        class="ml-2"
                      >
                        All Members
                      </v-list-item-content>
                      <v-icon
                        small
                        color="#1cc283"
                        class="mr-3"
                        v-text="
                          !getSearchedCalendarAssignedBy
                            ? 'mdi-check-box-outline'
                            : ''
                        "
                      ></v-icon>
                    </div>
                    <div
                      class="d-flex list-item-min-height caption listing-hover pointer"
                      v-for="member in filteredMembers"
                      :key="member.id"
                      @click="
                        getSearchedCalendarAssignedBy
                          ? getSearchedCalendarAssignedBy.id == member.id
                            ? ($store.commit('setCalendarTaskFilter', {
                                assigned_by: null,
                                page: 1,
                              }),
                              fetchCall())
                            : ($store.commit('setCalendarTaskFilter', {
                                assigned_by: member,
                                page: 1,
                              }),
                              fetchCall())
                          : ($store.commit('setCalendarTaskFilter', {
                              assigned_by: member,
                              page: 1,
                            }),
                            fetchCall());
                        assignedByDropdown = false;
                      "
                      :class="
                        getSearchedCalendarAssignedBy
                          ? getSearchedCalendarAssignedBy.id == member.id
                            ? 'bg-selected'
                            : ''
                          : ''
                      "
                    >
                      <profileImage
                        v-show="member.image ? ':src' : ':username'"
                        :src="member.image"
                        inline
                        :username="member.name ? member.name : member.email"
                        :size="23"
                        :userProfile="true"
                        :circular="true"
                        class="ml-3 text-light"
                      >
                      </profileImage>

                      <v-list-item-content
                        style="max-width: 160px"
                        class="d-inline-block text-truncate ml-2"
                        :class="member.name ? 'text-capitalize' : ''"
                      >
                        {{
                          member.name ? member.name : member.email
                        }}</v-list-item-content
                      >
                      <v-spacer></v-spacer>
                      <v-icon
                        small
                        color="#1cc283"
                        class="mr-3"
                        v-text="
                          getSearchedCalendarAssignedBy
                            ? getSearchedCalendarAssignedBy.id == member.id
                              ? 'mdi-check-box-outline'
                              : ''
                            : ''
                        "
                      ></v-icon>
                    </div>
                    <div v-if="searchMember && !filteredMembers.length">
                      <p class="no-results-found my-1">No results found</p>
                    </div>
                  </v-list>
                </div>
              </v-menu>
            </v-col>
          </v-row>
          <!-- divider -->
          <div v-if="getView == 'list'" class="border-bottom my-6"></div>
          <!-- FILTER BY TASK STATUS -->
          <v-row v-if="getView == 'list'">
            <v-col>
              <p class="dark-purple-text font-weight-bold body-2 mb-0">
                By Task Status
              </p>
              <div
                :class="[
                  isMac ? 'edited_scrollbar' : '',
                  !$vuetify.breakpoint.xs ? 'w-50' : '',
                ]"
              >
                <v-list max-height="200" class="pointer overflow-scroll">
                  <div
                    v-for="status in statusList"
                    :key="status.text"
                    class="status-list-min-height caption anchor-hover d-flex pointer"
                    @click="
                      $store.commit('setCalendarTaskFilter', {
                        status: status.text,
                      });
                      fetchCall();
                    "
                  >
                    <v-list-item-content>
                      <span class="text-capitalize">
                        <v-icon
                          small
                          color="#1cc283"
                          class="pr-2"
                          v-text="
                            getCalendarSearchedStatus
                              ? getCalendarSearchedStatus == status.text
                                ? 'mdi-checkbox-marked-circle'
                                : 'mdi-checkbox-blank-circle-outline'
                              : ''
                          "
                        ></v-icon>
                        <span
                          :class="
                            getCalendarSearchedStatus
                              ? getCalendarSearchedStatus == status.text
                                ? 'success-text font-weight-bold'
                                : ''
                              : ''
                          "
                        >
                          {{ status.text }}
                        </span>
                      </span>
                    </v-list-item-content>
                  </div>
                </v-list>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="border-top py-3">
          <div class="d-flex align-center w-100">
            <v-btn
              @click="resetFilters"
              depressed
              small
              color="#edebf9"
              class="text-capitalize"
            >
              <v-icon color="#2a206a" small>mdi-restore</v-icon>
              <span class="body-2 mx-1 dark-purple-text">Reset Filters</span>
            </v-btn>
            <v-spacer></v-spacer>
          </div>
        </v-card-actions>
        <!-- DROPDOWNS -->
        <!-- Project Dropdown -->
        <v-menu
          :close-on-content-click="false"
          activator="#calendar-project-dropdown"
          offset-y
          content-class="white"
        >
          <div :class="isMac ? 'edited_scrollbar' : ''">
            <!-- search field -->
            <div class="search-border py-0 ma-2 rounded">
              <v-text-field
                autocomplete="off"
                prepend-inner-icon="mdi-magnify"
                background-color="white"
                placeholder="Search..."
                class="body-2"
                color="#757096"
                hide-details
                solo
                flat
                dense
                v-model="projectSearch"
              >
              </v-text-field>
            </div>
            <v-list max-height="130" class="pointer overflow-scroll" scrollable>
              <div
                v-if="!projectSearch"
                class="d-flex list-item-min-height caption listing-hover pointer"
                @click="
                  $store.commit('setCalendarTaskFilter', {
                    project_id: null,
                    page: 1,
                  });
                  fetchCall();
                "
                :class="!getSearchedCalendarProject ? 'bg-selected' : ''"
              >
                <profileImage
                  v-show="':username'"
                  inline
                  username="All"
                  :size="23"
                  :userProfile="true"
                  :circular="true"
                  class="ml-3 text-light"
                >
                </profileImage>
                <v-list-item-content class="ml-2">
                  All Projects
                </v-list-item-content>
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    !getSearchedCalendarProject ? 'mdi-check-box-outline' : ''
                  "
                ></v-icon>
              </div>
              <div
                v-for="project in projectsList"
                :key="project.id"
                class="list-item-min-height caption listing-hover d-flex pointer"
                @click="
                  getSearchedCalendarProject
                    ? getSearchedCalendarProject.id == project.id
                      ? ($store.commit('setCalendarTaskFilter', {
                          project_id: null,
                          page: 1,
                        }),
                        fetchCall())
                      : ($store.commit('setCalendarTaskFilter', {
                          project_id: project.id,
                          page: 1,
                        }),
                        fetchCall())
                    : ($store.commit('setCalendarTaskFilter', {
                        project_id: project.id,
                        page: 1,
                      }),
                      fetchCall())
                "
                :class="
                  getSearchedCalendarProject
                    ? getSearchedCalendarProject.id == project.id
                      ? 'bg-selected'
                      : ''
                    : ''
                "
              >
                <profileImage
                  inline
                  :username="project.name"
                  :size="23"
                  :circular="true"
                  class="ml-3 text-light"
                >
                </profileImage>
                <v-list-item-content
                  ><span
                    style="width: 30px"
                    class="d-inline-block text-truncate ml-2 text-capitalize"
                  >
                    {{ project.name }}
                  </span>
                </v-list-item-content>
                <v-spacer></v-spacer>
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    getSearchedCalendarProject
                      ? getSearchedCalendarProject.id == project.id
                        ? 'mdi-check-box-outline'
                        : ''
                      : ''
                  "
                ></v-icon>
              </div>
              <div v-if="projectSearch && !projectsList.length">
                <p class="no-results-found my-1">No results found</p>
              </div>
            </v-list>
          </div>
        </v-menu>
        <!-- Assigned To Dropdown -->
        <v-menu
          :close-on-content-click="false"
          activator="#calendar-assigned-to-dropdown"
          offset-y
          content-class="white"
        >
          <div :class="isMac ? 'edited_scrollbar' : ''">
            <!-- search field -->
            <div class="search-border rounded ma-2">
              <v-text-field
                autocomplete="off"
                prepend-inner-icon="mdi-magnify"
                background-color="white"
                placeholder="Search..."
                class="body-2"
                color="#757096"
                hide-details
                dense
                solo
                flat
                v-model="searchMember"
              />
            </div>
            <v-list max-height="130" class="overflow-scroll" scrollable>
              <div
                v-if="!searchMember"
                class="d-flex list-item-min-height caption listing-hover pointer"
                @click="
                  $store.commit('setCalendarTaskFilter', {
                    assigned_to: null,
                    page: 1,
                  });
                  fetchCall();
                "
                :class="!getSearchedCalendarAssignedTo ? 'bg-selected' : ''"
              >
                <profileImage
                  v-show="':username'"
                  inline
                  username="All"
                  :size="23"
                  :userProfile="true"
                  :circular="true"
                  class="ml-3 text-light"
                >
                </profileImage>
                <v-list-item-content
                  @click="assignedToDropdown = false"
                  class="ml-2"
                >
                  All Members
                </v-list-item-content>
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    !getSearchedCalendarAssignedTo
                      ? 'mdi-check-box-outline'
                      : ''
                  "
                ></v-icon>
              </div>
              <div
                class="d-flex pointer list-item-min-height caption listing-hover"
                v-for="member in filteredMembers"
                :key="member.id"
                @click="
                  getSearchedCalendarAssignedTo
                    ? getSearchedCalendarAssignedTo.id == member.id
                      ? ($store.commit('setCalendarTaskFilter', {
                          assigned_to: null,
                          page: 1,
                        }),
                        fetchCall())
                      : ($store.commit('setCalendarTaskFilter', {
                          assigned_to: member,
                          page: 1,
                        }),
                        fetchCall())
                    : ($store.commit('setCalendarTaskFilter', {
                        assigned_to: member,
                        page: 1,
                      }),
                      fetchCall());
                  assignedToDropdown = false;
                "
                :class="
                  getSearchedCalendarAssignedTo
                    ? getSearchedCalendarAssignedTo.id == member.id
                      ? 'bg-selected'
                      : ''
                    : ''
                "
              >
                <profileImage
                  v-show="member.image ? ':src' : ':username'"
                  :src="member.image"
                  inline
                  :username="member.name ? member.name : member.email"
                  :size="23"
                  :userProfile="true"
                  :circular="true"
                  class="ml-3 text-light"
                >
                </profileImage>

                <v-list-item-content
                  style="max-width: 160px"
                  class="d-inline-block text-truncate ml-2"
                  :class="member.name ? 'text-capitalize' : ''"
                >
                  {{
                    member.name ? member.name : member.email
                  }}</v-list-item-content
                >
                <v-spacer></v-spacer>
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    getSearchedCalendarAssignedTo
                      ? getSearchedCalendarAssignedTo.id == member.id
                        ? 'mdi-check-box-outline'
                        : ''
                      : ''
                  "
                ></v-icon>
              </div>

              <div v-if="searchMember && !filteredMembers.length">
                <p class="no-results-found my-1">No results found</p>
              </div>
            </v-list>
          </div>
        </v-menu>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/main";
import { projectsCRUD } from "@/mixins/projectsCRUD";
import { memberSearchMixin } from "@/mixins/memberSearchMixin";
import _ from "lodash";
export default {
  name: "CalendarFilters",
  mixins: [projectsCRUD, memberSearchMixin],
  components: {
    profileImage: () => import("@/components/Includes/ProfileImage"),
  },
  data() {
    return {
      titleSearchCalendar: null,
      searchMember: null,
      projectsAccordian: true,
      flag: false,
      calendarTasksFilterDropdown: false,
      projectsDropdown: false,
      assignedToDropdown: false,
      assignedByDropdown: false,
      projectSearch: null,
      commentDropdown: false,
      selected: "",
      calendarTasks: [],
      statusList: [{ text: "all" }, { text: "pending" }, { text: "completed" }],
    };
  },
  computed: {
    ...mapGetters([
      "getSelectedCompany",
      "getCalendarShowAllTasks",
      "getCalendarTaskDueDateFilter",
      "getSearchedCalendarProject",
      "getSearchedCalendarAssignedTo",
      "getSearchedCalendarAssignedBy",
      "getCalendarSearchedStatus",
      "getView",
    ]),
  },
  methods: {
    fetchCall() {
      this.$store.commit("setCalendarTasksLinearLoader", true);
      this.$store.dispatch("fetchCalendarTasks").then((res) => {
        this.$store.commit("setCalendarTasksLinearLoader", false);
        this.calendarTasks = res.data.data.tasks;
        eventBus.$emit("updateCalendar", this.calendarTasks);
        eventBus.$emit("filterApplied");
      });
    },
    changeShowAll(option) {
      if (option == "me")
        this.$store.commit("setCalendarTaskFilter", {
          show_tasks: option,
          assigned_by: null,
        });
      else
        this.$store.commit("setCalendarTaskFilter", {
          show_tasks: option,
        });
    },
    changeTaskDueDateFilter(due_date) {
      this.$store.commit("setCalendarTaskFilter", {
        due_date: due_date,
      });
    },
    resetFilters() {
      this.$store.commit("setCalendarTaskFilter", {
        project_id: null,
        assigned_to: null,
        assigned_by: null,
        status: "all",
        page: 1,
      });
      this.changeShowAll("me");
      this.changeTaskDueDateFilter(false);
      this.fetchCall();
    },
  },
  watch: {
    getCalendarShowAllTasks(value) {
      if (value) {
        this.fetchCall();
      }
    },
    getCalendarTaskDueDateFilter() {
      this.fetchCall();
    },
    titleSearchCalendar: {
      handler: _.debounce(function (value) {
        this.$store.commit("setCalendarTaskFilter", { title: value });
      }, 1000),
      deep: true,
    },
  },
};
</script>
<style scoped>
/* .radio-item input[type="radio"] {
  display: none;
}
.radio-item label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 2px;
  margin: 0 5px 0 0;
  width: 14px;
  height: 14px;
  border-radius: 11px;
  border: 2px solid #1cc283;
  background-color: transparent;
} */

/* .radio-item input[type="radio"]:checked + label:after {
  border-radius: 11px;
  width: 6px;
  height: 6px;
  position: relative;
  top: -14px;
  left: 8px;
  content: " ";
  display: block;
  background: #1cc283;
} */
.w-50 {
  width: 180px !important;
}
</style>
